import {makeAutoObservable, observable} from 'mobx';
import {SiteType} from '@wp-content-publisher/typings-lib/dist/src/server/types/site.ts';
import {ArticleType} from '@wp-content-publisher/typings-lib/dist/src/server/types/article.ts';


class MainPageStore<T extends SiteType | ArticleType > {
    displayedList = observable.box<T[]>([]);
    selectedList = observable.box<T[]>([]);

    constructor() {
        makeAutoObservable(this);
    }

    setDisplayedList = (items: T[]) => {
        const notInSelected = items.filter(({id}) => !this.selectedList.get().some(({id: sId}) => sId === id));
        this.displayedList.set(notInSelected);
    }

    moveItemToSelected = (items: T[]) => {
        this.selectedList.set([...this.selectedList.get(), ...items]); // TODO ???

        this.displayedList.set(
            this.displayedList.get()
                .filter(({id: dId}) => {
                    // TODO simplify after debbug
                    return !this.selectedList.get()
                            .some(({id: sId}) => {
                                return sId === dId
                            })
                    }
                )
        );
    };

    moveItemToDisplayed = (item: T) => {
        this.selectedList.set(this.selectedList.get().filter(({id}) => id !== item.id));
        this.displayedList.set([...this.displayedList.get(), item]);
    };

}

// const mainPageStore = new MainPageStore();
export {MainPageStore};